import React, { useEffect } from 'react';
import { View } from 'react-native';

import { useT } from '@transifex/react';

import { AuthLayout } from '../components/AuthLayout';
import Loading from '../components/Loading';
import { Logo } from '../components/Logo';
import ThemedText from '../components/ThemedText';
import { getVidaWebUrl } from '../config/runtimeConfig';
import { ROUTES } from '../utils/constants';
import { logout } from '../api/auth';
import { getToken, getRefreshToken, removeToken } from '../services/storageService';
import { useLoginRouter } from '../hooks/useLoginRouter';

export default function LogoutScreen() {
  const router = useLoginRouter();
  const t = useT();

  useEffect(() => {
    (async () => {
      const [accessToken, refreshToken] = await Promise.all([getToken(), getRefreshToken()]);
      if (accessToken && refreshToken) {
        await logout(refreshToken, accessToken);
      }
      // Invalidate Django session server-side. The nginx 301 clears the cookie
      // in the browser, but as a fallback we also kill the session in Django
      // so even a stale cookie is useless. `mode: 'no-cors'` makes this a
      // genuine fire-and-forget: the request (with cookies) still hits Django,
      // but the response is opaque so the browser doesn't surface a CORS error
      // when the legacy host doesn't expose Access-Control-Allow-Origin for
      // the apigee SPA host.
      fetch(`${getVidaWebUrl()}/logout/`, {
        method: 'GET',
        mode: 'no-cors',
        credentials: 'include',
      }).catch(() => {});
      await removeToken();
      router.replace(ROUTES.LOGIN);
    })();
  }, []);

  return (
    <AuthLayout>
      <View className='w-full'>
        <Logo />
        <View className='items-center justify-center py-16'>
          <Loading className='flex-none' />
          <ThemedText type='bodyRegular' color='subtle' className='mt-4'>
            {t('Signing out...')}
          </ThemedText>
        </View>
      </View>
    </AuthLayout>
  );
}
